import { makeObservable, observable, action } from "mobx";

import { queryTrafficPermissionList } from "utils/api";

// 订阅管理store
export default class TrafficPermissionStore {
  list = null;

  constructor() {
    makeObservable(this, {
      list: observable,
      queryTrafficPermissionList: action,
    });
  }

  async queryTrafficPermissionList(data) {
    const res = await queryTrafficPermissionList(data);
    
    console.log(res.data.result != null || !!res.data.result)
    if(res.data.result != null || !!res.data.result) {
      this.list = [...res.data.result.ipWhiteList];
    } else {
      this.list = [];
    }
    return res;
  }
}
